import { DataItem } from 'scrivito'

import { getSchemaAttributes } from '../schema'
import { getSchemaName } from '@/utils/dataClassMap'

export const getDataItemAttributesDefaultValues = (dataItem: DataItem) => {
  const dataClassName = dataItem.dataClassName()!
  const schemaName = getSchemaName(dataClassName)
  const { schemaAttributes } = getSchemaAttributes(schemaName)
  if (!schemaAttributes) return {}
  const attributesArray = Object.keys(schemaAttributes)

  const dataItemMap = attributesArray?.map((attribute) => {
    const fieldMap = {
      name: attribute,
      value: dataItem.get(attribute),
    }

    return fieldMap
  })

  const res = Object.fromEntries(dataItemMap.map((e) => [e.name, e.value]))

  return res
}
